export default "__VITE_ASSET__BLn81Kw___"